import {BrowserRouter, Routes, Route} from 'react-router'

import {Layout, ProviderLayout} from '~/react/router'
import NotFoundScreen from '~/react/screens/NotFoundScreen'

import PayBillScreen from './screens/PayBillScreen'
import SupplierBillScreen from './screens/SupplierBillScreen'

export default function Router(props) {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<ProviderLayout {...props} />}>
          {/* Payment Wizard does not use the default layout */}
          <Route
            path="points_on_payments/payments/:payableId"
            element={<PayBillScreen {...props} />}
          />
          <Route
            path="points_on_payments"
            element={
              <Layout
                {...props}
                supplierLayoutState="Pay bills"
                variant="secondary"
              />
            }
          >
            <Route
              index
              element={<SupplierBillScreen selectedTab="payBills" {...props} />}
            />

            <Route
              path="bills"
              element={<SupplierBillScreen selectedTab="payBills" {...props} />}
            />
            <Route
              path="payments"
              element={
                <SupplierBillScreen selectedTab="paidBills" {...props} />
              }
            />
          </Route>

          <Route
            path="*"
            element={<Layout {...props} supplierLayoutState="Not Found" />}
          >
            <Route path="*" element={<NotFoundScreen />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  )
}
